<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-text-editor
                    :validations="validations.descricao"
                    name="Descrição"
                    placeholder="Insira as demais informações relacionadas aos antecedentes dos familiares."
                    v-model="data.model.descricaoFamiliar"
                />
            </rkm-col>
        </rkm-row>

        <BoxProblemaFamiliar :data="data" />
    </div>
</template>

<script>
// Components.
import BoxProblemaFamiliar from './components/problema-familiar/Index'

export default {
    components: {BoxProblemaFamiliar},
    computed: {
        validations() {
            return {
                descricao: {max: 5000},
            }
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>